import { ApiServiceException as __BaseException } from "./ApiServiceException";
export class BadGateway extends __BaseException {
    constructor(opts) {
        super({
            name: "BadGateway",
            $fault: "server",
            ...opts
        });
        this.name = "BadGateway";
        this.$fault = "server";
        Object.setPrototypeOf(this, BadGateway.prototype);
    }
}
export class BadRequest extends __BaseException {
    constructor(opts) {
        super({
            name: "BadRequest",
            $fault: "client",
            ...opts
        });
        this.name = "BadRequest";
        this.$fault = "client";
        Object.setPrototypeOf(this, BadRequest.prototype);
    }
}
export class Forbidden extends __BaseException {
    constructor(opts) {
        super({
            name: "Forbidden",
            $fault: "client",
            ...opts
        });
        this.name = "Forbidden";
        this.$fault = "client";
        Object.setPrototypeOf(this, Forbidden.prototype);
    }
}
export class InternalServerError extends __BaseException {
    constructor(opts) {
        super({
            name: "InternalServerError",
            $fault: "server",
            ...opts
        });
        this.name = "InternalServerError";
        this.$fault = "server";
        Object.setPrototypeOf(this, InternalServerError.prototype);
    }
}
export class Locked extends __BaseException {
    constructor(opts) {
        super({
            name: "Locked",
            $fault: "client",
            ...opts
        });
        this.name = "Locked";
        this.$fault = "client";
        Object.setPrototypeOf(this, Locked.prototype);
    }
}
export class NotFound extends __BaseException {
    constructor(opts) {
        super({
            name: "NotFound",
            $fault: "client",
            ...opts
        });
        this.name = "NotFound";
        this.$fault = "client";
        Object.setPrototypeOf(this, NotFound.prototype);
    }
}
export class PreconditionFailed extends __BaseException {
    constructor(opts) {
        super({
            name: "PreconditionFailed",
            $fault: "client",
            ...opts
        });
        this.name = "PreconditionFailed";
        this.$fault = "client";
        Object.setPrototypeOf(this, PreconditionFailed.prototype);
    }
}
export class Unauthorized extends __BaseException {
    constructor(opts) {
        super({
            name: "Unauthorized",
            $fault: "client",
            ...opts
        });
        this.name = "Unauthorized";
        this.$fault = "client";
        Object.setPrototypeOf(this, Unauthorized.prototype);
    }
}
export class ValidationException extends __BaseException {
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts
        });
        this.name = "ValidationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.fieldList = opts.fieldList;
    }
}
export const ProductType = {
    DECLARATION_OF_CONDOMINIUM: "declarationOfCondominium",
    INFORMATION_ON_BUILDING_ENCUMBRANCES: "informationOnBuildingEncumbrances",
    INFORMATION_ON_CONTAMINATED_SITES: "informationOnContaminatedSites",
    LAND_REGISTER: "landRegister",
    NON_OFFICIAL_CADASTRALMAP: "nonOfficialCadastralMap",
    PARTITION_PLAN: "partitionPlan",
    REGISTRATION_APPROVAL: "registrationApproval",
};
export const AddressRegion = {
    BB: "BB",
    BE: "BE",
    BW: "BW",
    BY: "BY",
    HB: "HB",
    HE: "HE",
    HH: "HH",
    MV: "MV",
    NI: "NI",
    NW: "NW",
    RP: "RP",
    SH: "SH",
    SL: "SL",
    SN: "SN",
    ST: "ST",
    TH: "TH",
};
export const ItemStatus = {
    COMMISSIONED: "commissioned",
    DELIVERED: "delivered",
    NONE: "none",
    SYSTEM_CANCELED: "system_canceled",
};
export const OrderStatus = {
    CANCELED: "canceled",
    CLAIMED: "claimed",
    COMMISSIONED: "commissioned",
    CREATED: "created",
    DELIVERED: "delivered",
    ERROR: "error",
    IN_PAYMENT: "in_payment",
    PAYMENT_SUCCESS: "payment_success",
};
export class PreconditionRequired extends __BaseException {
    constructor(opts) {
        super({
            name: "PreconditionRequired",
            $fault: "client",
            ...opts
        });
        this.name = "PreconditionRequired";
        this.$fault = "client";
        Object.setPrototypeOf(this, PreconditionRequired.prototype);
    }
}
export const ProductDeliveryTime = {
    MULTIPLE_WEEKS: "MULTIPLE_WEEKS",
    ONE_TO_TWO_DAYS: "ONE_TO_TWO_DAYS",
};
